import { measure } from 'src/utils/perf';

import MediaStreamPipe from './base';
import { getImage } from './utils';

class RotateMediaStream extends MediaStreamPipe {
  private degree: number;

  private resize: boolean;

  private sourceWidth = 0;

  private sourceHeight = 0;

  private outputWidth = 0;

  private outputHeight = 0;

  constructor(degree: number, resize: boolean) {
    super();
    this.degree = degree;
    this.resize = resize;
  }

  private updateOutputSize() {
    let width = this.sourceWidth;
    let height = this.sourceHeight;
    if (this.resize) {
      if (width > (height / 16) * 9) {
        width = (height / 16) * 9;
      } else if (height > (width / 9) * 16) {
        height = (width / 9) * 16;
      }
    }
    [height, width] = [width, height];
    this.outputWidth = width;
    this.outputHeight = height;
    this.outputCanvasEls.forEach((outputCanvasEl) => {
      outputCanvasEl.width = width;
      outputCanvasEl.height = height;
    });
  }

  public renderVideo() {
    this.sourceWidth = 0;
    this.sourceHeight = 0;

    this.render = () => {
      const inputEl = this.inputEl;
      const size = this.getInputSize();
      if (!inputEl || !size || !size.width || !size.height) {
        return;
      }

      // video는 크기가 바뀌면 'resize' 이벤트로 renderVideo()가 다시 불려 크기를 재계산하지만,
      // canvas 입력은 그런 신호가 없다. 매 프레임 소스 크기를 비교해서 바뀌었을 때만 출력 캔버스 크기를 다시 세팅한다
      if (size.width !== this.sourceWidth || size.height !== this.sourceHeight) {
        this.sourceWidth = size.width;
        this.sourceHeight = size.height;
        this.updateOutputSize();
      }

      const { outputWidth: width, outputHeight: height, sourceWidth, sourceHeight } = this;

      measure('pipe.rotate.render', () => {
        this.outputCanvasEls.forEach((outputCanvasEl) => {
          const context = outputCanvasEl.getContext('2d');
          if (!context) {
            return;
          }
          context.save();
          context.clearRect(0, 0, width, height);
          context.translate(width / 2, height / 2);
          context.rotate((this.degree * Math.PI) / 180);
          const image = getImage(inputEl);
          if (image) {
            context.drawImage(image, -sourceWidth / 2, -sourceHeight / 2);
          }
          context.restore();
        });
      });
    };
  }
}

export default RotateMediaStream;
